// Simple registry for custom control providers
// A provider has the shape:
// {
//   id: string,
//   match: (object) => boolean,
//   create: (manager, object) => controlInstance
// }

const providers = [];

export function registerCustomControlProvider(provider) {
  if (!provider || typeof provider.create !== 'function') {
    console.warn('Invalid custom control provider registration');
    return;
  }
  providers.push(provider);
}

export function getCustomControlProviders() {
  return providers.slice();
}

export function findProviderForObject(object) {
  for (const p of providers) {
    try {
      if (typeof p.match === 'function' ? p.match(object) : false) {
        return p;
      }
    } catch (e) {
      // Ignore provider errors during matching to avoid breaking others
      console.error('Error in custom control provider match()', p.id, e);
    }
  }
  return null;
}
